import * as React from "react";
import classNames from "classnames";

export interface ICtaButtonProps {
    className?: string;
    isLarge?: boolean;
    isInverted?: boolean;
    isSecondary?: boolean;
    link: string;
    onClick?(): void;
}

const CtaButton = ({ className, isLarge, isInverted, isSecondary, link, onClick }: ICtaButtonProps) => {
    const baseClass = "cta-button";
    const componentClasses = classNames(className, baseClass, {
        [`${baseClass}--large`]: isLarge,
        [`${baseClass}--inverted`]: isInverted,
        [`${baseClass}--secondary`]: isSecondary
    });

    return <div onClick={onClick} className={componentClasses} dangerouslySetInnerHTML={{ __html: link }} />;
};

export default CtaButton;
